import axios from 'axios';

export default {
    async list({ paginated, page, status, search, completedOn, customer }) {
        if (!paginated)
            paginated = false;
        if (!page)
            page = 1;

        let customer_id = (customer) ? customer.id : null;

        let response = await axios.get('/api/carts', { params: { paginated, page, status, search, completedOn, customer_id }});
        return response.data;
    },
    paginatedList(options) {
        return this.list({ ...options, paginated: true });
    },
    async get(id) {
        let response = await axios.get(`/api/carts/${id}`);
        return response.data.data;
    },
    async find(code) {
        let response = await axios.get(`/api/carts/code/${code}`);
        return response.data.data;
    },
    async create(cart = {}) {
        let response = await axios.post('/api/carts', cart);
        return response.data.data;
    },
    async update(cart) {
        let response = await axios.patch(`/api/carts/${cart.id}`, cart);
        return response.data.data;
    },
    async roundUpTotal(cart) {
        let response = await axios.post(`/api/carts/${cart.id}/roundUpTotal`, cart);
        return response.data.data;
    },
    async reset(cart) {
        let response = await axios.post(`/api/carts/${cart.id}/reset`);
        return response.data.data;
    },
    async evaluate(cart) {
        let response = await axios.post(`/api/carts/${cart.id}/evaluate`);
        return response.data.data;
    },
    async accept(cart) {
        let response = await axios.post(`/api/carts/${cart.id}/accept`);
        return response.data.data;
    },
    async decline(cart) {
        let response = await axios.post(`/api/carts/${cart.id}/decline`, cart);
        return response.data.data;
    },
    async complete(cart) {
        let response = await axios.post(`/api/carts/${cart.id}/complete`, cart);
        return response.data.data;
    },
    async cancel(cart) {
        let response = await axios.post(`/api/carts/${cart.id}/cancel`);
        return response.data.data;
    },
    async getActivity(cart) {
        let response = await axios.get(`/api/carts/${cart.id}/activity`);
        return response.data;
    },
}
